import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { merchantsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useAgentsListQuery = ({ fetchData }) => {
	const dispatch = useDispatch();

	const { page, filters, sortBy } = fetchData;

	const queryResult = useQuery(
		["agentsQueue", page, filters, sortBy],
		() =>
			merchantsService.getAgents({
				page,
				sort: sortBy,
				filtersApplied: filters,
			}),
		{
			select: (data: {
				count: number;
				items: { [key: string]: any };
			}) => {
				const agents = data?.items?.map(agent => ({
					fullName: {
						firstName: agent.firstName,
						lastName: agent.lastName,
					},
					agentOffice: agent.agentOffice,
					role: agent.role,
					manager: agent.manager,
					businessUnit: agent.business_unit,
					businessUnitHierarchy: agent.business_unit_hierarchy,
					agent,
				}));

				return { count: data?.count, items: agents };
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useAgentsListQuery;
